import {Payload} from '../../../../../core/service/payload/payload';
import {FileLikeObject} from 'ng2-file-upload';

export class DocumentCreatePayload implements Payload {

    label: string;
    categoryValue: string;
    formatValue: string;
    attachment: FileLikeObject;
}
